import { Icon } from '../Icon/Icon'
import type { IconName } from '../Icon/types'
import { cx } from '../utils/cx'
import type { StatusChipProps, StatusTone } from './types'
import './StatusChip.css'

const DEFAULT_ICON: Record<StatusTone, IconName> = {
  success: 'check-circle',
  warning: 'clock',
  error: 'x-circle',
  info: 'info',
  neutral: 'circle',
}

/** Chip de estado de 28 px: fondo semántico suave, texto 13/600, icono 16 px. Nunca solo color. */
export function StatusChip({ tone = 'info', icon, children, className, style }: StatusChipProps) {
  return (
    <span className={cx('hp-chip', `hp-chip--${tone}`, className)} style={style}>
      <Icon name={icon ?? DEFAULT_ICON[tone]} size={16} />
      <span className="hp-chip__label">{children}</span>
    </span>
  )
}
